import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Users, BookOpen, Sparkles, Building2 } from 'lucide-react';
interface Group {
  id: string;
  name: string;
  role: string;
  memberCount: number;
  hasKnowledgeCenterAccess: boolean;
  hasChatbotModel: boolean;
}
const MOCK_GROUPS: Group[] = [{
  id: 'parkside-towers',
  name: 'Parkside Towers',
  role: 'Admin',
  memberCount: 24,
  hasKnowledgeCenterAccess: true,
  hasChatbotModel: true
}, {
  id: 'riverfront-plaza',
  name: 'Riverfront Plaza',
  role: 'Member',
  memberCount: 18,
  hasKnowledgeCenterAccess: true,
  hasChatbotModel: false
}, {
  id: 'the-metropolitan',
  name: 'The Metropolitan',
  role: 'Manager',
  memberCount: 32,
  hasKnowledgeCenterAccess: false,
  hasChatbotModel: false
}, {
  id: 'harbor-view-condos',
  name: 'Harbor View Condos',
  role: 'Admin',
  memberCount: 15,
  hasKnowledgeCenterAccess: true,
  hasChatbotModel: true
}, {
  id: 'lakewood-estates',
  name: 'Lakewood Estates',
  role: 'Member',
  memberCount: 8,
  hasKnowledgeCenterAccess: false,
  hasChatbotModel: false
}];
export function MyGroupsWidget() {
  const navigate = useNavigate();
  const handleKnowledgeCenterClick = (groupId: string) => {
    navigate(`/ai-copilot?workspace=${groupId}`);
  };
  const handleGroupAIClick = (groupId: string) => {
    navigate(`/ai-copilot?workspace=${groupId}&chat=new`);
  };
  const getRoleBadgeStyle = (role: string) => {
    switch (role.toLowerCase()) {
      case 'admin':
        return 'bg-violetBlue/10 text-violetBlue border-violetBlue/20';
      case 'manager':
        return 'bg-turquoise/10 text-turquoise border-turquoise/20';
      default:
        return 'bg-aliceBlue text-secondary border-borderColor';
    }
  };
  return <div className="bg-white border border-borderColor rounded-xl p-6 shadow-sm" data-id="element-275">
      {/* Header */}
      <div className="flex items-center gap-3 mb-6" data-id="element-276">
        <div className="p-2.5 bg-aliceBlue rounded-lg" data-id="element-277">
          <Users className="w-5 h-5 text-violetBlue" data-id="element-278" />
        </div>
        <div data-id="element-279">
          <h3 className="text-xl font-semibold text-primary" data-id="element-280">My Groups</h3>
          <p className="text-sm text-secondary" data-id="element-281">
            Groups and workspaces you belong to
          </p>
        </div>
      </div>

      {/* Groups List */}
      <div className="space-y-4" data-id="element-282">
        {MOCK_GROUPS.map(group => <div key={group.id} className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 p-4 rounded-xl border border-borderColor hover:border-violetBlue/30 transition-colors bg-white" data-id="element-283">
            {/* Group Info */}
            <div className="flex items-start sm:items-center gap-3" data-id="element-284">
              <div className="p-2 bg-aliceBlue rounded-lg hidden sm:block" data-id="element-285">
                <Building2 className="w-4 h-4 text-secondary" data-id="element-286" />
              </div>
              <div data-id="element-287">
                <div className="flex items-center gap-2 mb-1" data-id="element-288">
                  <h4 className="text-base font-semibold text-primary" data-id="element-289">
                    {group.name}
                  </h4>
                </div>
                <p className="text-sm text-secondary" data-id="element-290">
                  {group.memberCount} members
                </p>
              </div>
            </div>

            {/* Actions */}
            <div className="flex flex-wrap items-center gap-2 mt-2 sm:mt-0" data-id="element-291">
              {group.hasKnowledgeCenterAccess ? <>
                  <button onClick={() => handleKnowledgeCenterClick(group.id)} className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-violetBlue border border-violetBlue hover:bg-aliceBlue rounded-lg transition-colors" data-id="element-292">
                    <BookOpen className="w-4 h-4" data-id="element-293" />
                    Knowledge Center
                  </button>
                  {group.hasChatbotModel && <button onClick={() => handleGroupAIClick(group.id)} className="flex items-center gap-1.5 px-3 py-1.5 text-sm font-medium text-white bg-violetBlue hover:bg-[#6844E8] rounded-lg transition-colors" data-id="element-294">
                      <Sparkles className="w-4 h-4" data-id="element-295" />
                      LawVo AI
                    </button>}
                </> : <span className="text-xs text-secondary bg-aliceBlue px-3 py-1.5 rounded-lg" data-id="element-296">
                  Standard access only
                </span>}
            </div>
          </div>)}
      </div>
    </div>;
}